import { put, takeLatest } from "redux-saga/effects";
import { postUpdateInfomationStoreApi } from "store/api/InfomationStoreApi";
import { UPDATE_INFOMATION_STORE_ACTION } from "../../actions/InfomationStorePageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* showMessage(isError, message) {
	const alert = { isError: isError, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postUpdateInfomationStore(action) {
	yield put(globalAction.openLoadingPage());
	const { dataUpdate, onSuccess, onFail } = action.params;
	const res = yield postUpdateInfomationStoreApi(dataUpdate);
	try {
		if (res?.code === 0) {
			yield showMessage(false, res?.message);
			onSuccess();
		} else {
			yield showMessage(true, res?.message);
			onFail();
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postUpdateInfomationStoreSaga() {
	yield takeLatest(UPDATE_INFOMATION_STORE_ACTION, postUpdateInfomationStore);
}

export default postUpdateInfomationStoreSaga;
